import { Component, Inject, Input } from "@angular/core";
import { AUTH_SVC, AuthService } from "@company-box/services";

import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-sidebar-nav-link",
  standalone: true,
  template: `
    @if(!isExternalLink()) {
      <a
        [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
        routerLinkActive="active"
        [routerLink]="[link.url]"
        >
        @if(isIcon()) {
          @for (i of icons; track $index) {
            <i class="{{ i }}"></i>
          }
        }
        {{ link.name }}
        @if(isBadge()) {
          <span [ngClass]="'badge text-bg-' + link.badge.variant">{{ link.badge.text }}</span>
        }
      </a>
    } @else {
      <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{ link.url }}">
        @if(isIcon()) {
          <i class="{{ link.icon }}"></i>
        }
        {{ link.name }}
        @if(isBadge()) {
          <span [ngClass]="'badge text-bg-' + link.badge.variant">{{ link.badge.text }}</span>
        }
      </a>
    }
    `,
  imports: [RouterModule, CommonModule],
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  constructor(@Inject(AUTH_SVC) private authService: AuthService) {}

  public hasAccess() {
    if (this.link.roles) {
      return this.authService.validate(undefined, this.link.roles, "");
    }
    return true;
  }

  public hasVariant() {
    return this.link.variant ? true : false;
  }

  public isBadge() {
    return this.link.badge ? true : false;
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === "http" ? true : false;
  }

  public isIcon() {
    return this.link.icon ? true : false;
  }

  get icons(): any[] {
    if (Array.isArray(this.link.icon)) {
      return this.link.icon;
    }
    return [this.link.icon];
  }
}
